<template>
  <section id="content">
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box">
          <div class="box-header">
              <label for="recordPerPage" class="col-sm-1 col-md-1 col-lg-1" style="margin-top: 10px; text-align:left">Show</label>
              <div class="col-sm-2 col-md-2 col-lg-1" style="padding-left:0px;">
                <select v-on:change="changePageSize" ref="recordPerPage" class="form-control">
                  <option v-if="inquiryParam.pageSize == 5" selected>5</option><option v-else>5</option>
                  <option v-if="inquiryParam.pageSize == 10" selected>10</option><option v-else>10</option>
                  <option v-if="inquiryParam.pageSize == 20" selected>20</option><option v-else>20</option>
                  <option v-if="inquiryParam.pageSize == 50" selected>50</option><option v-else>50</option>
                  <option v-if="inquiryParam.pageSize == 100" selected>100</option><option v-else>100</option>
                </select>
              </div>          
              <div class="box-tools">
                <button class="btn btn-default" data-toggle="modal" data-target="#modal-filter">Filter</button>
                <button v-on:click="inquiry" class="btn btn-warning">Search</button>                
              </div>
          </div>        
          <div class="box-body no-padding table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th style="width: 45px;text-align:right;">#</th>
                  <th style="text-align:center;">Action</th>
                  <th style="text-align:center;">ID</th>
                  <th style="text-align:left;">Project</th>
                  <th style="text-align:center;">Order ID</th>                    
                  <th style="text-align:center;">Payment ID</th> 
                  <th style="text-align:center;">Payment Item ID</th>
                  <th style="text-align:left;">Payment Method</th>
                  <th style="text-align:center;">Booking Date</th>
                  <th style="text-align:center;">Is Used</th>
                  <th style="text-align:center;">Using Date</th>
                  <th style="text-align:left;">Item</th>   
                  <th style="text-align:left;">Item Name</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, i) in listData" v-bind:key="i">
                  <td style="width:45px;text-align:right;">{{ startSequence + i + 1}}</td>
                  <td style="width:45px;text-align:center;">
                    <a href="#" v-on:click="onDisplay(row)" ref="displayRow" style="padding-right:5px">
                      <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                    </a>
                    <a href="#" v-on:click="onGenerateQR(row)" ref="displayRow" style="padding-right:5px">
                      <span class="icon ion-qrcode" data-toggle="tooltip" data-placement="right" title="Generate QR Code"></span>
                    </a>
                  </td>
                  <td style="text-align:center;" nowrap>{{ row.id }}</td>
                  <td style="text-align:center;" nowrap>{{ row.project_name }}</td>   
                  <td style="text-align:center;" nowrap>{{ row.order_id }}</td>                    
                  <td style="text-align:center;" nowrap>{{ row.payment_id }}</td>
                  <td style="text-align:center;" nowrap>{{ row.payment_item_id }}</td>
                  <td style="text-align:left;" nowrap>{{ row.payment_method_name }}</td>
                  <td style="text-align:center;" nowrap>{{ row.booking_date }}</td>
                  <td style="text-align:center;"><input type="checkbox" :checked= row.is_used></td>
                  <td style="text-align:center;" nowrap>{{ row.using_date }}</td>                 
                  <td style="text-align:left;" nowrap>{{ row.item_id }}</td>
                  <td style="text-align:left;" nowrap>{{ row.item_name }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="box-footer">
            <div class="form-group">
              <label style="width:25px;text-align:right;">
                  <a href="#"><i v-on:click="changePage(1)" class="icon ion-ios-rewind"></i></a>
              </label>
              <label style="width:35px;text-align:center;">
                  <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber - 1)" class="icon ion-arrow-left-b"></i></a>
              </label>
              <label>
                  Page
              </label>
              <label>
                  <input v-model="inquiryParam.CurrentPageNumber" v-on:keyup.enter="gotoPage($event)" class="form-control" id="CurrentPage" style="width:50px;margin-left:5px;margin-right:5px;">
              </label>
              <label id="TotalPageText">
                {{ totalPages }}                
              </label>
              <label style="width:35px;text-align:center;">
                  <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber + 1)" class="icon ion-arrow-right-b"></i></a>
              </label>
              <label style="width:25px;text-align:left;">
                  <a href="#"><i v-on:click="changePage(totalPages)" class="icon ion-ios-fastforward"></i></a>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modal-filter" style="display: none;">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span></button>
            <h4 class="modal-title">Filter</h4>
          </div>
          <div class="modal-body">
            <div class="box-body no-border form-horizontal">
              <div class="form-group">
                <label class="col-md-2 control-label">ID</label>
                <div class="col-md-10">
                    <input type="text" id="filterId" v-model="searchParam.id" style="width:100%">
                </div>                     
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">Order ID</label>
                <div class="col-md-10">
                  <input type="text" id="filterOrderId" v-model="searchParam.order_id" style="width:100%">
                </div>                     
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">Payment ID</label>
                <div class="col-md-10">
                  <input type="text" id="filterOrderId" v-model="searchParam.payment_id" style="width:100%">
                </div>                     
              </div>             
              <div class="form-group">
                <label class="col-md-2 control-label">Is Used</label>
                <div class="col-md-10">
                  <input type="checkbox" id="filterOrderId" v-model="searchParam.is_used">
                </div>                     
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">Booking Date</label>
                <div class="col-md-10">
                  <div class="input-group">
                    <datepicker v-if="showBookingDateFrom" :value=searchParam.booking_date_from :format=DATE_FORMAT :input-attr="{ 'id': 'filterBookingDateFrom' }" :input-style="{ 'width': '100%' }"></datepicker>
                    <label>to</label>
                    <datepicker v-if="showBookingDateTo" :value=searchParam.booking_dateto :format=DATE_FORMAT :input-attr="{ 'id': 'filterBookingDateTo' }" :input-style="{ 'width': '100%' }"></datepicker>
                  </div>
                </div>                     
              </div>                                                                     
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" ref="btnCloseModal">Close</button>
            <button type="button" class="btn btn-primary" data-dismiss="modal" @click="onApplyFilter($event)">Apply</button>
            <button type="button" class="btn btn-primary" @click="onResetFilter($event)">Reset</button>
          </div>
        </div>
      </div>
    </div>
    <div id="modal-qris" class="modal-dialog-qris" style="display:none">
      <div class="popup">
        <h2 class="modal-title"><strong>QR Passcode</strong></h2>
        <div id="qrcode" class="qris">
        </div>
        <div id="message" style="color:red"></div>  
      </div>
    </div>
  </section>  
</template>

<script>
import $ from 'jquery'
import moment from 'moment'
import api from '../../api'
import SweetAlert from 'sweetalert2'
import datepicker from '../../components/widgets/DatePicker'
import config from '../../config'

const MODE_VIEW = 'read'
// const MODE_UPDATE = 'update'
const STATUS_PENDING = 'pending'
const STATUS_SETTLEMENT = 'settlement'

export default {
  name: 'PassCode',
  components: {
    datepicker
  },
  data() {
    return {
      DATE_FORMAT: config.dateFormat,
      DATE_FORMAT_SQL: config.dateFormatSql,
      DATETIME_FORMAT_ISO: config.dateTimeFormatSql,
      STATUS_PENDING: STATUS_PENDING,
      STATUS_SETTLEMENT: STATUS_SETTLEMENT,
      listData: null,
      totalRows: 0,
      totalPages: 0,
      startSequence: 0,
      inquiryParam: {
        WhereClause: '',
        CurrentPageNumber: 1,
        PageSize: 10,
        SortDirection: 'DESC',
        SortExpression: 'created_date',
        WhereClauseByProject: ''
      },
      searchParam: {
        id: '',
        order_id: '',
        payment_id: '',
        is_used: false,
        booking_date_from: '',
        booking_date_to: ''
      },
      tabActive: '',
      showBookingDateFrom: true,
      showBookingDateTo: true
    }
  },
  computed: {
  },
  created() {
    this.inquiry()
  },
  mounted() {
    this.$refs.recordPerPage.value = this.inquiryParam.PageSize
    this.$root.$on('inquiryPassCodeByProject', (projectIds) => {
      this.projectIds = projectIds
      return this.inquiry()
    })
  },
  methods: {
    changePageSize(evt) {
      this.inquiryParam.PageSize = evt.target.value
      this.inquiryParam.CurrentPageNumber = 1
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    gotoPage(evt) {
      if (evt.target.value > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else if (evt.target.value < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    changePage(page) {
      if (page < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      } else if (page > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else {
        this.inquiryParam.CurrentPageNumber = page
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    onSearch(evt) {
      // var keyWords = evt.target.value
      // var whereClause = ['id', 'like', '\'%' + keyWords + '%\'']
      // this.inquiryParam.WhereClause = whereClause.join(' ')
      this.inquiry()
    },
    inquiry() {
      this.inquiryParam.WhereClauseByProject = ''
      if (this.$store.state.userInfo.projects && this.$store.state.userInfo.projects.length > 0) {
        this.inquiryParam.WhereClauseByProject = 'project_id IN (' + this.$store.state.userInfo.projects.join() + ')'
        this.inquiryParam.WhereClauseByProject = this.inquiryParam.WhereClause === '' ? this.inquiryParam.WhereClauseByProject : this.inquiryParam.WhereClauseByProject + ' AND '
      }

      let baseUrl = config.environment === 'Local' ? '/api/Gate' : '/api/Gate/' + this.$store.state.userInfo.projects[0]
      api
        .request('Gate', 'get', baseUrl + '/InquiryPassCode?WhereClause=' + this.inquiryParam.WhereClauseByProject + this.inquiryParam.WhereClause +
                                 '&PageSize=' + this.inquiryParam.PageSize + '&CurrentPageNumber=' + this.inquiryParam.CurrentPageNumber +
                                 '&SortDirection=' + this.inquiryParam.SortDirection + '&SortExpression=' + this.inquiryParam.SortExpression, null)
        .then(response => {
          var data = response.data
          this.listData = data.entity
          this.total = data.totalRows
          this.totalPages = data.totalPages
          this.$refs.recordPerPage.value = this.inquiryParam.PageSize
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onDisplay(row) {
      let params = {
        id: row.id,
        mode: MODE_VIEW,
        callback: this.$route.name
      }
      this.$router.push({ name: 'PassCodeForm', params: params })
    },
    onGenerateQR(row) {
      const qrCodeString = row.id + '|' + row.payment_method_name

      // SweetAlert.fire({
      //   title: 'Passcode QR',
      //   html: '<img src="https://chart.googleapis.com/chart?cht=qr&chl=' + qrCodeString + '&chs=260x260&chld=L|0" class="img-responsive img-thumbnail"> <br>' +
      //         '<h3 style="color:red; font-weight:bold;">' + row.id + '</h3>',
      //   // type: 'info',
      //   showConfirmButton: false,
      //   showCloseButton: true,
      //   showLoaderOnConfirm: true
      // })
      // .then((result) => {
      // })

      document.getElementById('qrcode').innerHTML = ''
      var qr = new window.QRCode(document.getElementById('qrcode'), {
        width: 350,
        height: 350
      })
      qr.makeCode(qrCodeString)
      window.$('#modal-qris').modal('show')
      document.getElementById('message').innerHTML = row.id
    },
    onApplyFilter() {
      var filterParams = []
      if (this.searchParam.id !== '') {
        filterParams.push(['id', '=', '\'' + this.searchParam.id + '\''])
      }
      if (this.searchParam.order_id !== '') {
        filterParams.push(['order_id', '=', '\'' + this.searchParam.order_id + '\''])
      }
      if (this.searchParam.payment_id !== '') {
        filterParams.push(['payment_id', '=', '\'' + this.searchParam.payment_id + '\''])
      }
      if ($('#filterBookingDateFrom').val() !== '') {
        this.searchParam.booking_date_from = $('#filterBookingDateFrom').val()
        var dateFrom = moment(this.searchParam.booking_date_from, this.DATE_FORMAT)
        dateFrom = moment(dateFrom).format(this.DATE_FORMAT_SQL)
        filterParams.push(['booking_date', '>=', '\'' + dateFrom + '\''])
      }
      if ($('#filterBookingDateTo').val() !== '') {
        this.searchParam.booking_date_to = $('#filterBookingDateTo').val()
        var dateTo = moment(this.searchParam.booking_date_to, this.DATE_FORMAT)
        dateTo = moment(dateTo).format(this.DATE_FORMAT_SQL)
        filterParams.push(['booking_date', '<=', '\'' + dateTo + '\''])
      }
      filterParams.push(['is_used', '=', '\'' + this.searchParam.is_used + '\''])

      var whereClause = []
      var j = 0
      for (let i = 0; i < filterParams.length; i++) {
        whereClause[j] = filterParams[i].join(' ')
        j++
      }
      this.inquiryParam.WhereClause = whereClause.join(' AND ')
      this.onSearch()
    },
    onResetFilter() {
      this.inquiryParam.WhereClause = ''
      this.searchParam.id = ''
      this.searchParam.order_id = ''
      this.searchParam.payment_id = ''
      this.searchParam.booking_date_from = ''
      this.searchParam.booking_date_to = ''
      this.searchParam.is_used = false

      this.showBookingDateFrom = false
      this.$nextTick(() => {
        this.showBookingDateFrom = true
      })

      this.showBookingDateTo = false
      this.$nextTick(() => {
        this.showBookingDateTo = true
      })
    }
  }
}
</script>

<style scoped>
.modal-dialog-qris {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height:100%;
    background-color: rgba(0,0,0,0.5);
    z-index:1900;
}

.modal-dialog-qris .popup{
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    margin: auto;
    width:600px;
    height:500px;
    text-align:center;
    font-size:20px;
    font-weight:bold;
    background-color: #F0EEEE;
    border-radius: 3px;
    box-shadow: 0px 10px 20px rgba(0,0,0,0.4);
    z-index:1950;
    font-family: 'Lato';
    font-family: Lato;
}

.modal-dialog-qris .popup .qris{
    display: inline-flex;
    padding: 20px;
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}

.q_avatar {
  float: left;
  box-sizing: border-box;
  position: relative;
  text-align: inherit;
}
.q_avatar > img {
  max-height: 90px;
  max-width: 90px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  border: none;
}
.q_form_image_controls {
  position: absolute;
  top: 0;
  left: auto;
  bottom: auto;
  right: 0;
  width: 100%;
  color: white;
  background-color: #337AB7;
  opacity: 0;
  transition: opacity ease 400ms;
}
.q_hidden_input_file {
  position: absolute;
  top: 1px;
  opacity: 0;
  width: 100%;
  height: 26px;  
  display: none;
}
.q_form_image_controls > .ion {
  margin: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// PassCode.vue?69689eb8